export default __webpack_public_path__ + "static/media/Babawale Suit - Cybersecurity Practice Lead.fcf1dece.png";